import { Field } from "formik";
const LocationBrain = (props) => {
  return (
    <>{props.showhidecomponent && 
      <div>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Disable Amount Confirmation When Processing Credit Card
              </label>
              <Field
                type="checkbox"
                style={{ width: "1.25em", height: "1.25em" }}
                className="form-check-input"
                //   onChange={handleChange}
                id="DisableAmountConfirmation"
                name="DisableAmountConfirmation"
              />
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
                Use Integrated EBT
              </label>
              <Field
                type="checkbox"
                style={{ width: "1.25em", height: "1.25em" }}
                className="form-check-input"
                //   onChange={handleChange}
                id="UseIntegratedEBT"
                name="UseIntegratedEBT"
              />
            </div>
          </div>
        </div>
        <div className="row">
        <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
              Merchant ID
              </label>
              <div className="col-md-9">
                <Field
                  type="number"
                  className="form-control"
                  // onChange={handleChange}
                  id="BraintreeMerchantid"
                  name="BraintreeMerchantid"
                />
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
              Public Key
              </label>
              <div className="col-md-9">
                <Field
                  type="text"
                  className="form-control"
                  // onChange={handleChange}
                  id="Publickey"
                  name="Publickey"
                />
              </div>
            </div>
          </div>
          <div className="col-sm-6">
            <div className="form-group row">
              <label className="col-form-label col-md-3 form-label">
              Private Key
              </label>
              <div className="col-md-9">
                <Field
                  type="text"
                  className="form-control"
                  // onChange={handleChange}
                  id="Privatekey"
                  name="Privatekey"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
}
    </>
  );
};
export default LocationBrain;
